import { CommonModule } from '@angular/common';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
const _c0 = (a0, a1, a2) => ({
  "margin": a0,
  "flex": a1,
  "inline": a2
});
const _c1 = (a0, a1) => ({
  width: a0,
  height: a1
});
function UiSpinnerComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.label);
  }
}
export const SpinnerComponentStyles = {
  dotPreloader: `<g><circle stroke="none" cx="15" cy="50" r="12">
	<animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.1"/>
	</circle>
	<circle stroke="none" cx="50" cy="50" r="12">
	<animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.2"/>
	</circle>
	<circle stroke="none" cx="85" cy="50" r="12">
	<animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.3"/>
	</circle></g>`,
  circlePreloader: `<g>
	<circle stroke="currentColor" opacity=".3" stroke-width="10" fill="none" cx="50" cy="50" r="40"/>
	<circle stroke="currentColor" stroke-dasharray="30,200" stroke-width="10" fill="none" cx="50" cy="50" r="40">
	<animateTransform attributeName="transform" attributeType="XML" type="rotate" dur="1s" from="0 50 50" to="360 50 50" repeatCount="indefinite" /></circle>
	</g>`
};
// NOTE: prefer to use layouted ui-loading-indicator for typical use cases!
export let UiSpinnerComponent = /*#__PURE__*/(() => {
  class UiSpinnerComponent {
    constructor() {
      this.size = 36;
      this.margin = true;
      this.inline = false;
    }
    static {
      this.ɵfac = function UiSpinnerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UiSpinnerComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: UiSpinnerComponent,
        selectors: [["ui-spinner"]],
        inputs: {
          size: "size",
          label: "label",
          margin: "margin",
          inline: "inline"
        },
        decls: 7,
        vars: 10,
        consts: [[3, "ngClass"], ["version", "1.1", "xmlns", "http://www.w3.org/2000/svg", "xmlnsXlink", "http://www.w3.org/1999/xlink", "x", "0px", "y", "0px", "viewBox", "0 0 100 100", "enable-background", "new 0 0 100 100", "xmlSpace", "preserve", "fill", "currentColor", 3, "ngStyle"], ["stroke", "currentColor", "opacity", ".3", "stroke-width", "10", "fill", "none", "cx", "50", "cy", "50", "r", "40"], ["stroke", "currentColor", "stroke-dasharray", "30,200", "stroke-width", "10", "fill", "none", "cx", "50", "cy", "50", "r", "40"], ["attributeName", "transform", "attributeType", "XML", "type", "rotate", "dur", "1s", "from", "0 50 50", "to", "360 50 50", "repeatCount", "indefinite"], [1, "label"]],
        template: function UiSpinnerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(1, "svg", 1)(2, "g");
            i0.ɵɵelement(3, "circle", 2);
            i0.ɵɵelementStart(4, "circle", 3);
            i0.ɵɵelement(5, "animateTransform", 4);
            i0.ɵɵelementEnd()()();
            i0.ɵɵconditionalCreate(6, UiSpinnerComponent_Conditional_6_Template, 2, 1, "span", 5);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(3, _c0, ctx.margin, !ctx.inline, ctx.inline));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction2(7, _c1, ctx.size + "px", ctx.size + "px"));
            i0.ɵɵadvance(5);
            i0.ɵɵconditional(ctx.label ? 6 : -1);
          }
        },
        dependencies: [CommonModule, i1.NgClass, i1.NgStyle],
        styles: ["div.flex[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;flex-direction:column}div.flex.margin[_ngcontent-%COMP%]{margin:20px 0}div.flex[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{margin-top:10px;text-align:center}div.inline[_ngcontent-%COMP%]{display:inline-flex;flex-direction:row;align-items:center}div.inline.margin[_ngcontent-%COMP%]{margin:0 5px}div.inline[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{margin-left:10px}"],
        changeDetection: 0
      });
    }
  }
  return UiSpinnerComponent;
})();